import { TSectionDouble } from "../../../components/MiniCards/MiniCardsDoubleData";
import { TMetricasResumen } from "../../../services/OmniaService";

type TMetricasResumenCardConverterProps = {
    original: TMetricasResumen;
    nuevo: TMetricasResumen;
}

export const MetricasResumenCardConverter = ({ original, nuevo }: TMetricasResumenCardConverterProps) : TSectionDouble[] => {

    const fecha = original.fecha.toString().split("T")[0]

    const result: TSectionDouble[] = [
        {
            title: "Volatilidad",
            data: `${original.volatilidad.toString()}%`,
            newData: `${nuevo.volatilidad.toString()}%`
        },
        {
            title: "Mejoría por Diversificación",
            data: `${original.mejoria_por_diversificacion.toString()}%`,
            newData: `${nuevo.mejoria_por_diversificacion.toString()}%`
        },
        {
            title: "Reducción Riesgo",
            data: `${original.pct_reduccion_riesgo.toString()}%`,
            newData: `${nuevo.pct_reduccion_riesgo.toString()}%`
        },
        {
            title: "Índice Diversificación",
            data: `${original.volatilidad.toString()}%`,
            newData: `${nuevo.volatilidad.toString()}%`
        },
        {
            title: "Núm. Instrumentos",
            data: `${original.numero_instrumentos.toString()}`,
            newData: `${nuevo.numero_instrumentos.toString()}`
        },
        {
            title: "Fecha",
            data: `${fecha}`
        },
    ];


    return result;
}